/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_My_Applications_TitleInputs */

const en_candidate_my_applications_title = /** @type {(inputs: Candidate_My_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My applications`)
};

const de_candidate_my_applications_title = /** @type {(inputs: Candidate_My_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Bewerbungen`)
};

/**
* | output |
* | --- |
* | "My applications" |
*
* @param {Candidate_My_Applications_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_my_applications_title = /** @type {((inputs?: Candidate_My_Applications_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_My_Applications_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_my_applications_title(inputs)
	return en_candidate_my_applications_title(inputs)
});